import React, { useState, useRef, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { LogOut, User, ChevronDown } from 'lucide-react';

const Header: React.FC = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const userName = authState?.idToken?.claims?.name as string || 'User';
  const userEmail = authState?.idToken?.claims?.email as string || '';

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleLogout = async () => {
    await oktaAuth.signOut();
  };

  return (
    <header className="h-16 bg-cargo-surface border-b border-cargo-border flex items-center justify-between px-6">
      <div />

      <div className="flex items-center gap-4">
        {/* User menu */}
        <div className="relative" ref={menuRef}>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-cargo-hover/50 transition-colors"
          >
            <div className="w-8 h-8 bg-cargo-accent/20 rounded-full flex items-center justify-center">
              <User className="w-4 h-4 text-cargo-accent" />
            </div>
            <span className="text-sm text-cargo-text font-medium hidden sm:block">
              {userName}
            </span>
            <ChevronDown className="w-4 h-4 text-cargo-muted" />
          </button>

          {menuOpen && (
            <div className="absolute right-0 top-full mt-2 w-56 bg-cargo-surface border border-cargo-border rounded-lg shadow-xl z-50 py-1">
              <div className="px-4 py-3 border-b border-cargo-border">
                <p className="text-sm font-medium text-cargo-text">{userName}</p>
                <p className="text-xs text-cargo-muted truncate">{userEmail}</p>
              </div>
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-2 px-4 py-2.5 text-sm text-cargo-muted hover:text-cargo-error hover:bg-cargo-hover/50 transition-colors"
              >
                <LogOut className="w-4 h-4" />
                Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
